module.exports = __webpack_public_path__ + "img/genfrei_negativ.134ac465.png";